import { ListProductsRequestListProductsFiltersInterface, ProductType as ApiProductType } from '@vendasta/billing';

export interface ListProductsFilter {
  hasDiscount?: boolean;
  hasPricingOverride?: boolean;
  skus?: string[];
  productType?: ProductType[];
}

export enum ProductType {
  Invalid,
  Standard,
  Vendasta,
  Subscription,
  Fee,
  PartnerSupportSales,
}

export function listProductsFilterToApi(filter: ListProductsFilter): ListProductsRequestListProductsFiltersInterface {
  return {
    ...filter,
    productType: (filter.productType || []).map((pt) => productTypeToApi(pt)),
  };
}

function productTypeToApi(productType: ProductType): ApiProductType {
  switch (productType) {
    case ProductType.Standard:
      return ApiProductType.PRODUCT_TYPE_STANDARD_PRODUCT;
    case ProductType.Vendasta:
      return ApiProductType.PRODUCT_TYPE_VENDASTA_PRODUCT;
    case ProductType.Subscription:
      return ApiProductType.PRODUCT_TYPE_SUBSCRIPTION;
    case ProductType.Fee:
      return ApiProductType.PRODUCT_TYPE_FEE;
    case ProductType.PartnerSupportSales:
      return ApiProductType.PRODUCT_TYPE_PARTNER_SUPPORT_SALES;
  }
  return ApiProductType.PRODUCT_TYPE_INVALID;
}
